/**
 * Input Schema of Motorista
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'
import {TipoVeiculoCollection} from '@/model/collection/TipoVeiculoCollection'
import {TipoCarroceriaCollection} from '@/model/collection/TipoCarroceriaCollection'
import {TipoMarcaVeiculoCollection} from '@/model/collection/TipoMarcaVeiculoCollection'

export class InputMotoristaSchema extends Schema {
  readonly name = 'InputMotorista'
  cpfExist: boolean | null = null
  tipoVeiculosOptions: any[] = []
  async loadOptions() {
    const tipoVeiculoCollection = await new TipoVeiculoCollection().options()
    const rawItems = await tipoVeiculoCollection.all()
    this.tipoVeiculosOptions = rawItems
  }

  readonly fieldSet: FieldSet<Motorista> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
        inputClass: 'uppercase',
      },
    }),
    cpf: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'cpf',
        label: this.translateFrom(schema.fieldName),
        required: true,
        value: this.cpfExist,
        validation: 'required',
      },
      on: {
        input: async () => {
          if (schema.model.cpf?.length === 11)
            await schema.model.checkCpfExist()
        },
      },
    }),
    rg: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'rg',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    celular: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'phone',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required|phone',
      },
    }),
    placaVeiculo: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        mask: ['AAA #X##'],
        maxlength: 8,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required|max:8|min:7',
        inputClass: 'uppercase',
      },
    }),
    dataNascimento: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'date',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    email: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'email',
        label: this.translateFrom(schema.fieldName),
        validation: 'email',
        inputClass: 'uppercase',
      },
    }),
    tipoVeiculoFkAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        type: 'text',
        label: this.translateFrom(schema.fieldName),
        items: this.tipoVeiculosOptions,
        required: true,
        validation: 'required',
      },
    }),
    tipoCarroceriaAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        type: 'text',
        items: new TipoCarroceriaCollection().options().all(),
        label: this.translateFrom(schema.fieldName),
      },
    }),
    placaCarroceira: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        mask: ['AAA #X##'],
        maxlength: 8,
        label: this.translateFrom(schema.fieldName),
        validation: 'max:8|min:7',
        inputClass: 'uppercase',
      },
    }),
    antt: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 123,
        label: this.translateFrom(schema.fieldName),
        inputClass: 'uppercase',
      },
    }),
    cnh: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 45,
        label: this.translateFrom(schema.fieldName),
        inputClass: 'uppercase',
      },
    }),
    marcaVeiculoAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        type: 'text',
        items: new TipoMarcaVeiculoCollection().options().all(),
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    nomeIndicador: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        inputClass: 'uppercase',
      },
    }),
  }
}
